import { useDispatch, useSelector } from "react-redux"
import { selectUserInfo } from "../../../features/User/userSlice"
import { selectTranslations } from "../../../services/i18n/i18nSlice"
import { selectAppPersonalizations } from "../../../services/utils/appInfoSlice"

import mail_img from './../images/mail.svg' 
import wh_img from './../images/whatsapp.svg' 
import right_img from '../../../assets/images/right.svg'
import support_img from '../images/assistenza.svg'
import tf_logo from '../../../assets/images/logo_tf_horizontal.svg'
import BRAND from '../../../brand'

import { TitleH2 } from "../../../components/TitleH2"
import { Text } from "../../../components/Text"

export const SUPPORT_EMAIL = 'assistenza@thefaculty.it'
export const SUPPORT_WHATSAPP = 'https://wa.me/393336899449'

export default function ContactModule (props) {

    const t = useSelector(selectTranslations)
    const personalizations = useSelector(selectAppPersonalizations)

    const communicationsEmail = personalizations?.communications_email || null

    return (
        <div id="contactModule">
            <div className="mt-0 mt-md-4 page_title">
                <img src={support_img} />
                <TitleH2 className="mb-0">{t.account.contact}</TitleH2>
            </div>
            <Text className="mt-2">{communicationsEmail ? t.account.contact_text_email : t.account.contact_text}</Text>
            <div className="contact_cards mt-3 mb-3">
                {communicationsEmail ? (
                    <a href={`mailto:${communicationsEmail}`} target="_blank" rel="noreferrer">
                        <div className="contact_card">
                            <img src={mail_img} alt="" />
                            <div>
                                <TitleH2>E-mail</TitleH2>
                                <Text>{communicationsEmail}</Text>
                            </div>
                            <img src={right_img} alt="" />
                        </div>
                    </a>
                ) : (
                    <>
                        <a href={SUPPORT_WHATSAPP} target="_blank" rel="noreferrer">
                            <div className="contact_card">
                                <img src={wh_img} alt="" />
                                <div>
                                    <TitleH2>WhatsApp</TitleH2>
                                    <Text>{t.account.whatsapp_text}</Text>
                                </div>
                                <img src={right_img} alt="" />
                            </div>
                        </a>
                        <a href={`mailto:${SUPPORT_EMAIL}`} target="_blank" rel="noreferrer">
                            <div className="contact_card">
                                <img src={mail_img} alt="" />
                                <div>
                                    <TitleH2>E-mail</TitleH2>
                                    <Text>{t.account.email_text}</Text>
                                </div>
                                <img src={right_img} alt="" />
                            </div>
                        </a>
                    </>
                )}
            </div>
            {BRAND.supportByTf && <div className="support_by mb-4">
                <Text className="mb-0">{t.account.support_by}</Text>
                <img src={tf_logo} alt="thefaculty" />
            </div>}
            <span className='pt-5 mt-5'>
                App version: {process.env.REACT_APP_VERSION}
            </span>
        </div>
    )
}
